import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44da3d0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal",
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  id: "google-event-modal",
  "aria-labelledby": "`google-event-label`",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "google-event-label"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Date: ", -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "modal-footer" }

import $ from 'jquery';
import { computed, ref, inject } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import { Booking } from "@/models";
import { emitEvent } from '@/eventBus';
import Ably from "ably";

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleEventModal',
  props: {
    booking: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

// Vuex store
const store = useStore();
const realtime: Ably.Realtime = inject('realtime');
const toasted = useToast();
const actProperty: any = inject('actProperty');

// Computed and Ref
const channel: Ably.Types.RealtimeChannelCallbacks = realtime.channels.get('diary');
const deviceid = actProperty.getDeviceId();

// Methods
const restoreBookingInStore = async (booking: Booking): Promise<Booking> => {
  return await store.dispatch('diary/restoreBooking', booking);
};

const restore = async () => {
  try {
    await restoreBookingInStore(props.booking);
    toasted.success("Booking restored");
    channel.publish('appointmentRestored', { deviceid: deviceid, bookingid: props.booking.id });
    emitEvent(
          "appointmentRestoredInBookingTemplate",
          props.booking
        );
  } catch (err: any) {
    actProperty.displayError(err);
  }
};

const show = () => {
  const backdropDiv = $('<div class="modal-backdrop fade show" id="myModalBackdrop"></div>');
  $('body').append(backdropDiv);
  $(`#google-event-modal`).show();
}

const hide = () => {
  $('#myModalBackdrop').remove();
  $(`#google-event-modal`).hide();
};
__expose({show, hide });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.booking.summary), 1),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.booking.startdate || _ctx.booking.enddate)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(_toDisplayString(_ctx.booking.bookingdate) + " from " + _toDisplayString(_ctx.booking.starttime) + " to " + _toDisplayString(_ctx.booking.endtime), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", {
            innerHTML: _ctx.booking.description
          }, null, 8, _hoisted_13)
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.booking.cancelled)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-secondary mr-auto",
                "data-dismiss": "modal",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (restore()), ["prevent"]))
              }, " Restore "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, " Close ")
        ])
      ])
    ])
  ]))
}
}

})